// extracted by mini-css-extract-plugin
module.exports = {"v-icon":"NsAddressNc_v-icon_2FtoC","nsAddressForm":"NsAddressNc_nsAddressForm_1cqx3","dualColumn":"NsAddressNc_dualColumn_1Rzkz","firstCol":"NsAddressNc_firstCol_11Qhi"};